<template>
  <!-- <div class="shop_wrapper">
    <div class="container">
      <div class="row">
				<div class="col-md-12"> -->

					<div class="search_bar">
            <form action="#">
              <input type="text"
              	:placeholder=" $t('Buscar producto...') " 
              	@keyup="getData" 
					      v-model="search" 
					      @blur="hideResults(0)" 
					      @focus="showResults"
					      @keyup.enter="submitSearch">
              <button @click.prevent="submitSearch" type="submit">
                <img v-if=" searchLoading " :src=" getBaseUrl + '/assets-own/images/loading-rainbow-bg-w.svg' " width="20" height="20" alt="Spinning">
                <i v-else class="ion-ios-search-strong"></i>
              </button>
            </form>
            <div v-if=" (terms && showSearchResults) || isREF " class="search-results"> 
			        <template v-if=" isREF && search.length >= refShow && search.length <= 4 ">
			          <div class="search-results-row">
			            <div class="stable">
			              <div class="srow">          
			                <div class="scell result-term">
			                  {{ $t('Para completar una Referencia faltan') + ' ' + ( 4 - search.length ) + ' ' + $t('dígitos') }}</div>
			              </div>
			            </div>
			          </div>
			        </template>   
			        <div v-else v-for=" (term, index) in terms" :key="index" class="search-results-row">        	
			          <router-link
			            :to="{ name: 'type', params: { 
			            	lin: setUrlParams(term.lin_id,term.lin_name),
			            	ctg: setUrlParams(term.ctg_id,term.ctg_name),
			            	sct: setUrlParams(term.sct_id,term.sct_name),
			            	typ: setUrlParams(term.typ_id,term.typ_name)
			             } }" 
			            @click.native="hideResults(1)">
			            <div class="stable">
			              <div class="srow">
			                <div :class="'scell box bg-'+ term.lin_name.toLowerCase()">{{ term.lin_name.substring(0, 1) }}</div>
			                <div class="scell result-img"><img :src=" getBaseUrl + getImgUrl + term.ref_image " alt=""></div>
			                <div class="scell result-ref">{{ term.ref_number }}</div>
                      <div v-if="term.hasOwnProperty('ref_stock')" class="scell result-stck pr-2">
                        <i class="fa fa-bar-chart float-left ml-2 mt-1"></i>
                        {{ term.ref_stock }}
                      </div>
			                <div class="scell result-term pr-2">{{ term.ref_description }}</div>
			                <div v-if=" term.ref_price > 0 " class="scell btn-add">
                        <a href="#" @click.prevent=" addItem(term) " class="btn-biv c-bg-grey-blue add-to-card"><i class="fa fa-plus-circle"></i></a>
                      </div>
			              </div>
			            </div>
			          </router-link>
			        </div>
              <div v-if=" terms.length == 0 " class="no-results">
                {{ $t('No hay resultados') }}
              </div>
			      </div>
          </div>


				<!-- </div>
  		</div>
    </div>
  </div> -->
</template>

<i18n>
  {
		"es": {
      "Buscar producto...": "Buscar producto...",
      "No hay resultados": "No hay resultados",
      "Para completar una Referencia faltan": "Para completar una Referencia faltan",
      "dígitos": "dígitos"
    },
    "en":{
      "Buscar producto...": "Search product...",
      "No hay resultados": "No results",
      "Para completar una Referencia faltan": "To complete a Reference there are missing",
      "dígitos": "digits"
    }
  }
</i18n>

<script>

	import Spinner from './components/helpers/Spinner.vue';

	import { mapGetters, mapActions } from 'vuex';
	import { mixinGlobal } from './mixins/mixinGlobal';

	export default {
		mixins: [ mixinGlobal ],
		components: { Spinner },
	  data () {
	    return {
	    	terms: false,     // Response
        search: '',       // Search term
        cancelToken: '',
        source: '',
        showSearchResults: true,
        timeout: null,
        refShow: 20,
        isREF: false,
        searchLoading: false,
        urlLocale: 'es',
	    }
	  },
	  mounted(){
    },
	  computed: {	
      ...mapGetters( ['getApiUrl', 'getBaseUrl', 'getImgUrl'] ),		
    },
    methods: {
      ...mapActions(['addItemShoppingCart']),
    	getData(){
        if(this.search.length>=1){
          let isNum = /^\d+$/.test(this.search);
          if( this.search.length >= this.refShow && isNum )  {
            this.isREF = true;
          }else{
            this.isREF = false;
            clearTimeout(this.timeout);

            this.searchLoading = true

            this.timeout = setTimeout(function() {
              if(this.cancelToken!='' && this.source!=''){
                this.source.cancel();   
              }
              this.cancelToken = this.$axios.CancelToken;
              this.source = this.cancelToken.source();

              this.$axios.get( this.getApiUrl + 'buscador.php?buscar='+this.search, {cancelToken: this.source.token}).then(response => {
                  this.terms = response.data; 
                  //console.log(response)
                  this.searchLoading = false
                  
              }).catch((thrown) => {
                if (this.$axios.isCancel(thrown)) {
                  console.log('Request canceled');
                } else {
                  this.terms = [];
                }
                this.searchLoading = false
              });

            }.bind(this), 300);
          }
        } 
      },
      submitSearch(){
        /*document.activeElement.blur();
        if(this.isREF){
          this.$router.push({ name: 'catalogo', params: { language: this.getLocale, category: 'indice' }, query: { CODIGO: this.search, ref: 'buscador' } });
        }else{
          this.$router.push({ name: 'catalogo', params: { language: this.getLocale, category: 'indice' }, query: { TITULO: this.search, ref: 'buscador' } });
        }*/
      },
      addItem(item){
        item.updateValue = 1
        //console.log(item)
				this.$store.dispatch('addItemShoppingCart', item);
			},
      showResults(){ this.showSearchResults = true; },
      hideResults(tmp){
        if(tmp){
          this.showSearchResults = false;
        }else{
          setTimeout(() => {
            this.showSearchResults = false;
          }, 300);
        }
      },
    }
	}
</script>
<style lang="css" scoped>
  .btn-add{
    width: 46px;
    text-align: right;
  }
  .btn-biv:hover{
    color: #FFF;
  }
</style>
